(() => {
  if (customElements.get('fd-contact')) return;

  const PAGE_SECTION = 'fd-contact';

  function send(name, idKey, id) {
    try {
      const params = { page_section: PAGE_SECTION };
      if (idKey && id) params[idKey] = id;
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, params));
      }
    } catch (error) {
    }
  }

  class FdContact extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      if (!window.fdContactPageViewSent) {
        window.fdContactPageViewSent = true;
        send('contact_page_view');
      }

      this.onClick = (event) => {
        const link = event.target.closest && event.target.closest('a[data-fd-contact-event]');
        if (!link || !this.contains(link)) return;
        send(link.dataset.fdContactEvent, 'contact_id', link.dataset.fdContactId);
      };

      this.onToggle = (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open) return;
        if (!details.dataset.fdContactEvent) return;
        send(details.dataset.fdContactEvent, 'faq_id', details.dataset.fdContactId);
      };

      this.addEventListener('click', this.onClick);
      this.addEventListener('toggle', this.onToggle, true);
      this.watchEmbed();
    }

    watchEmbed() {
      const embed = this.querySelector('.fd-contact__embed');
      if (!embed || embed.classList.contains('is-sized')) return;
      const settle = () => {
        const frame = embed.querySelector('iframe');
        const height = frame && frame.getAttribute('height');
        if (!height || !/^\d+(\.\d+)?$/.test(height) || !(Number(height) > 0)) return;
        embed.classList.add('is-sized');
        this.embedObserver.disconnect();
      };
      this.embedObserver = new MutationObserver(() => {
        clearTimeout(this.embedTimer);
        this.embedTimer = setTimeout(settle, 400);
      });
      this.embedObserver.observe(embed, { childList: true, subtree: true, attributes: true, attributeFilter: ['height'] });

      this.onPageLoad = () => {
        if (embed.querySelector('iframe')) return;
        this.embedObserver.disconnect();
        embed.classList.add('is-unavailable');
        const note = this.querySelector('.fd-contact__unavailable');
        if (note) note.hidden = false;
      };
      if (document.readyState === 'complete') this.onPageLoad();
      else window.addEventListener('load', this.onPageLoad, { once: true });
    }

    disconnectedCallback() {
      if (this.embedObserver) this.embedObserver.disconnect();
      if (this.onPageLoad) window.removeEventListener('load', this.onPageLoad);
      clearTimeout(this.embedTimer);
      if (this.onClick) this.removeEventListener('click', this.onClick);
      if (this.onToggle) this.removeEventListener('toggle', this.onToggle, true);
      this.bound = false;
    }
  }

  customElements.define('fd-contact', FdContact);
})();
